module.exports = __webpack_public_path__ + "img/conimg2-02.1363adb1.png";